<template>
  <v-form :disabled="disabled" @submit.prevent="validateForm">
    <div v-if="!hideDelete">
      <label for="reason-1">Motivo de rechazo: </label>
      <v-select
        v-model="form.firstReason"
        :items="firstReasonOptions"
        class="card-shadow mb-4"
        name="reason-1"
        placeholder="Seleccionar"
        hide-details
        solo
      />
      <label for="reason-2">2do. Motivo de rechazo:</label>
      <v-textarea
        v-model="form.secondReason"
        class="card-shadow mb-4"
        name="reason-2"
        placeholder="......"
        hide-details
        solo
      />
    </div>
    <v-alert v-if="errors.length > 0" dense outlined color="red">
      <div v-for="(e, index) in errors" :key="index">
        {{ e }}
      </div>
    </v-alert>

    <div :class="hideDelete ? 'mt-7' : 'd-flex mt-7'">
      <v-btn
        :class="hideDelete ? 'red-button' : 'red-button red-button--light'"
        width="130px"
        text
        :disabled="deleted"
        @click="$emit('onCancel')"
      >
        <span v-if="hideDelete">Cerrar</span>
        <span v-else>Cancelar</span>
      </v-btn>
      <v-spacer />
      <v-btn
        v-if="!hideDelete"
        class="red-button"
        width="130px"
        text
        type="submit"
        :disabled="disabled"
      >
        Eliminar
      </v-btn>
    </div>
  </v-form>
</template>

<script>
  export default {
    name: 'DeleteReasonsForm',

    props: {
      value: {
        type: Object,
        default: () => ({ firstReason: '', secondReason: '' }),
      },

      firstReasonOptions: {
        type: Array,
        default: () => [
          'A1 = Canc. Rec. Por Falt. Inventario',
          'A2 = Canc. Rec. Por Tiempo de Entrega',
          'A3 = Canc. Rec. Error del Cte.',
          'A4 = Canc. Rec. Por Error de Captura',
          'A5 = Pedido de Reemplazo',
          'A6 = Previa Cancelación x Lim. Cred.',
        ],
      },

      noValidateFirsReason: Boolean,
      noValidateSecondReason: Boolean,
      hideCancel: Boolean,
      hideDelete: Boolean,
      disabled: Boolean,
      deleted: Boolean,
    },

    data() {
      return {
        errors: [],
      };
    },

    computed: {
      form: {
        set(newVal) {
          this.$emit('input', { ...newVal });
        },

        get() {
          return this.value;
        },
      },
    },

    methods: {
      validateForm() {
        this.errors = [];

        if (!this.noValidateFirsReason && this.form.firstReason === '')
          this.errors.push('Completa el primer motivo de rechazo');

        if (!this.noValidateSecondReason && this.form.secondReason === '')
          this.errors.push('Completa el segundo motivo de rechazo');

        if (this.errors.length === 0) this.$emit('onDelete', this.form);
      },
    },
  };
</script>
